import type { PropsWithChildren } from "react";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { fetchAiOfferPendingCount } from "../../api/aiOfferBatches";
import { useImpersonation } from "../../hooks/useImpersonation";
import { AiOfferPendingCount } from "../../view_models/aiOfferPendingCount";

// UnreadMatchingProvider と同じ作り。画面遷移のたびに確認待ちバッチ数を取り直す。
export const AiOfferPendingProvider: React.FC<PropsWithChildren> = (props) => {
  const [, setPendingCount] = useRecoilState(AiOfferPendingCount);
  const impersonation = useImpersonation();
  const location = useLocation();

  useEffect(() => {
    const nonAuthPages = ["/sign-in", "/sign-up", "/reset-password", "/new-password"];
    if (nonAuthPages.includes(location.pathname)) {
      return;
    }
    // Phase 1 は代理ログイン中だけの機能なので、通常ログインでは問い合わせない。
    if (!impersonation.loaded || !impersonation.active) {
      return;
    }

    let mounted = true;
    fetchAiOfferPendingCount()
      .then((count) => {
        if (!mounted) {
          return;
        }
        setPendingCount((prev) => (prev.pending_count === count ? prev : { pending_count: count }));
      })
      .catch(() => {
        // 取得に失敗してもバッジが出ないだけなので握りつぶす。
      });

    return () => {
      mounted = false;
    };
  }, [location.pathname, impersonation.loaded, impersonation.active, setPendingCount]);

  return <>{props.children}</>;
};
